import { render } from "./CardQuestion.vue?vue&type=template&id=dad900d8&scoped=true"
import script from "./CardQuestion.vue?vue&type=script&lang=js"
export * from "./CardQuestion.vue?vue&type=script&lang=js"

import "./CardQuestion.vue?vue&type=style&index=0&id=dad900d8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad900d8"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg,QIcon,QBtn,QDialog,QCardSection,QRating,QInnerLoading});qInstall(script, 'directives', {ClosePopup});
